import React from 'react'
import CosmicNebulaMastercard from './cursor-wander-card'

interface HudsonDarkCardProps {
  memberName?: string
  membershipTier?: 'Standard' | 'Premium' | 'Elite'
  memberSince?: string
  className?: string
}

const HudsonDarkCard: React.FC<HudsonDarkCardProps> = ({
  memberName = "HUDSON MY HOME MEMBER",
  membershipTier = 'Elite',
  memberSince = "2024",
  className = ""
}) => {
  // Hudson blue/green theme (deep teal)
  const hudsonTheme = {
    primaryColor: "#0D3135", // rgb(13,49,53)
    secondaryColor: "#145F6C", // rgb(20,95,108)
    glowColor: "rgba(20, 95, 108, 0.6)"
  }

  const logoText = {
    topText: "HUDSON MY HOME",
    bottomText: membershipTier.toUpperCase()
  }

  const logoUrl = "https://nuykijziltpoqaszbrwi.supabase.co/storage/v1/object/public/site-images/HMH_Secondary_Logo_Tape%20Turquoise.png"

  return (
    <div className={`relative ${className}`}>
      {/* Custom styled cosmic card with slower animations */}
      <div className="relative">
        <CosmicNebulaMastercard
          cardholderName={memberName.toUpperCase()}
          logoText={logoText}
          theme={hudsonTheme}
          width="420px"
          height="265px"
          className="hudson-dark-card rounded-xl overflow-hidden"
        />
        
        {/* Custom overlay for Hudson My Home styling */}
        <div className="absolute inset-0 pointer-events-none">
          {/* Top left brand logo */}
          <div className="absolute top-4 left-4">
            <img src={logoUrl} alt="Hudson My Home" className="h-6 w-auto opacity-90 drop-shadow" />
          </div>

          {/* Top right membership tier badge */}
          <div className="absolute top-6 right-6">
            <div
              className="px-3 py-1 backdrop-blur-sm rounded-full border"
              style={{ backgroundColor: 'rgba(20,95,108,0.35)', borderColor: 'rgba(255,255,255,0.2)' }}
            >
              <span className="text-white/90 text-xs font-medium tracking-wider">
                {membershipTier.toUpperCase()} MEMBER
              </span>
            </div>
          </div>
          
          {/* Bottom left member info */}
          <div className="absolute bottom-6 left-6">
            <div className="text-white/80 text-xs font-light">
              {memberSince && `MEMBER SINCE ${memberSince}`}
            </div>
          </div>
          
          {/* Center watermark logo overlay */}
          <div className="absolute inset-0 flex items-center justify-center opacity-15">
            <img src={logoUrl} alt="Hudson My Home watermark" className="h-20 w-auto" />
          </div>
        </div>
      </div>

      {/* Slow pulsing glow effect in teal */}
      <div 
        className="absolute inset-0 -z-10 rounded-lg opacity-30 animate-pulse"
        style={{
          background: `radial-gradient(ellipse at center, ${hudsonTheme.secondaryColor}33 0%, transparent 70%)`,
          animationDuration: '4s',
          filter: 'blur(20px)'
        }}
      />
      
      {/* Global CSS injection for slower animations */}
      <style dangerouslySetInnerHTML={{
        __html: `
          .hudson-dark-card {
            transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1) !important;
          }
          
          .hudson-dark-card:hover {
            transform: translateY(-8px) rotateX(5deg) !important;
            filter: drop-shadow(0 25px 50px rgba(20, 95, 108, 0.45)) !important;
          }
          
          .hudson-dark-card .cosmic-animation {
            animation-duration: 8s !important;
          }
          
          .hudson-dark-card .particle-system * {
            animation-duration: 12s !important;
          }
          
          .hudson-dark-card .aurora-effect {
            animation-duration: 15s !important;
          }
        `
      }} />
    </div>
  )
}

export default HudsonDarkCard 